import React, { useEffect, useState } from "react";
import axios from "axios";
import { useFormik } from "formik";
import { validateEditForm } from "../schema/validationSchema";
import MobileMaskedInput from "../components/commonComponents/MobileMaskedInput";
import { useDispatch, useSelector } from "react-redux";
import { useTravellerHandlers } from "../customHooks/useTravellerHandlers";
import SubmitButton from "../components/commonComponents/SubmitButton";
import { updateMastersData } from "../../redux/slices/MastersDataSlice";
import { toast } from "react-toastify";
import API from "../../utils/API";
import { useRef } from "react";
import { MdArrowDropUp } from "react-icons/md";
import { IoMdArrowDropdown } from "react-icons/io";
import { RxCross1 } from "react-icons/rx";
import { CiCalendar } from "react-icons/ci";
import { getDobFromAge, iso2Map } from "../utility/utilityFunctions";

const getTripTypeForDurationApi = (tripType) => {
  if (tripType === "Annual Multi Trip") return "MultiTrip";
  if (tripType === "Student") return "Student";
  return "";
};

const normalizeDurationOptions = (durations) =>
  Array.isArray(durations)
    ? durations
        .map((item) => {
          const key = item?.Days ?? item?.key;
          const label =
            item?.DisplayText ??
            item?.label ??
            (key ? `${key} day${Number(key) === 1 ? "" : "s"}` : "");

          if (key === undefined || key === null || key === "") return null;
          return {
            key: String(key),
            value: String(label || key),
          };
        })
        .filter(Boolean)
    : [];
const EditDetailForm = ({ props, closeModal, updateDetails }) => {
  const MIN_ADULT_AGE = 18;
  const MAX_MEMBERS = 4;
  const MAX_CHILDREN = 2;

  const defaultInitialValues = {
    destination: [],
    mobileNo: "",
    selectedTripType: "Single",
    numberOfDays: null,
    startDate: "",
    endDate: "",
    travellers: [{ dob: "", age: null, relation: "" }],
  };

  const [initialValues, setInitialValues] = useState(defaultInitialValues);
  const mastersData = useSelector((state) => state.MastersData);
  const travellerDetails = useSelector((state) => state.TravellerDetails);
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);
  console.log(travellerDetails);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [popularLoading, setPopularLoading] = useState(true);
  const [openSelect, setOpenSelect] = useState({ index: -1, type: "" }); // "age" | "relation"
  const prevTripTypeRef = useRef(defaultInitialValues.selectedTripType);
  const lastManualDatesRef = useRef({ startDate: "", endDate: "" });

  const handleTripTypeChange = (value) => {
    setFieldValue("selectedTripType", value, true);
    if (value === "Student") {
      setFieldValue("numberOfDays", "", true);
    } else if (value === "Annual Multi Trip") {
      setFieldValue("numberOfDays", "10", true);
    } else {
      setFieldValue("numberOfDays", null, true);
    }
  };

  useEffect(() => {
    if (mastersData?.tripTypeList?.length < 1) getTripTypeList();
  }, [mastersData.tripTypeList]);

  const getTripTypeList = async () => {
    try {
      const res = await axios.post("services/call", {
        URL: "/Master/GetTripType",
      });
      if (res.data.StatusCode === 200)
        dispatch(updateMastersData({ tripTypeList: res.data.Response }));
    } catch (err) {
      console.log({ err });
    }
  };

  const getCountryMaster = async () => {
    try {
      if (mastersData?.countryList?.length > 0) return;
      const model = { URL: "GetCountries", PostString: JSON.stringify([]) };
      const Res = await API.CallRequestWithHeader(model);
      if (Res?.Response?.length > 0) {
        const mapped = Res.Response.map((c) => ({
          ...c,
          label: c.CountryName,
          value: c.Id,
        }));
        dispatch(updateMastersData({ countryList: mapped }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getPopularCountryMaster = async () => {
    try {
      if (mastersData?.popularCountries?.length > 0) {
        setPopularLoading(false);
        return;
      }
      setPopularLoading(true);
      const model = {
        URL: "GetPopularCountries",
        PostString: JSON.stringify([]),
      };
      const Res = await API.CallRequestWithHeader(model);
      if (Res?.Response?.length > 0) {
        const mapped = Res.Response.map((c) => ({
          ...c,
          label: c.CountryName,
          value: c.Id,
        }));
        dispatch(updateMastersData({ popularCountries: mapped }));
      } else {
        dispatch(updateMastersData({ popularCountries: [] }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setPopularLoading(false);
    }
  };

  const getRelationMaster = async () => {
    try {
      if (mastersData?.relationList?.length > 0) return;
      const model = { URL: "GetRelationTypeList" };
      const Res = await API.CallRequestWithHeader(model);
      if (Res?.Response?.length > 0) {
        dispatch(updateMastersData({ relationList: Res.Response }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAgeMaster = async () => {
    try {
      if (mastersData?.ageList?.length > 0) return;
      const model = { URL: "GetAgeItemList" };
      const Res = await API.CallRequestWithHeader(model);
      if (Res?.Response?.length > 0) {
        dispatch(updateMastersData({ ageList: Res.Response }));
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDurationDaysMaster = async () => {
    try {
      if (mastersData?.durationDaysList?.length > 0) return;
      const model = { URL: "GetDurationDays" };
      const Res = await API.CallRequestWithHeader(model);
      const response = Array.isArray(Res?.Response) ? Res.Response : [];
      dispatch(updateMastersData({ durationDaysList: response }));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCountryMaster();
    getPopularCountryMaster();
    getRelationMaster();
    getAgeMaster();
    getDurationDaysMaster();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formik = useFormik({
    initialValues,
    validationSchema: validateEditForm,
    enableReinitialize: true,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: async () => {
      await submitDetails();
    },
  });

  const { addTraveller, removeTraveller } = useTravellerHandlers(formik);
  const {
    values,
    errors,
    touched,
    handleChange,
    handleBlur,
    setFieldValue,
    setFieldTouched,
    validateField,
    setErrors,
    isSubmitting,
  } = formik;

  const autoDateTrip =
    values.selectedTripType === "Student" ||
    values.selectedTripType === "Annual Multi Trip";
  const durationTripType = getTripTypeForDurationApi(values.selectedTripType);
  const durationApiGroup = React.useMemo(
    () =>
      (mastersData?.durationDaysList || []).find(
        (item) =>
          String(item?.TripType || "").toLowerCase() ===
          durationTripType.toLowerCase(),
      ),
    [mastersData?.durationDaysList, durationTripType],
  );
  const effectiveDurationOptions = React.useMemo(() => {
    const durationOptions = normalizeDurationOptions(
      durationApiGroup?.Durations,
    );
    return durationOptions.length > 0
      ? durationOptions
      : Array.from({ length: 30 }, (_, i) => ({
          value: String(i + 1),
          label: `${i + 1} day${i === 0 ? "" : "s"}`,
        }));
  }, [durationApiGroup?.Durations]);
  const syncAutoReturnDate = (startDateValue, daysValue) => {
    const days = Number(daysValue) || 0;
    const nextEndDate =
      startDateValue && days > 0 ? addDaysYMD(startDateValue, days) : "";
    if (String(values.endDate || "") === String(nextEndDate || "")) {
      return;
    }
    setFieldValue("endDate", nextEndDate, true);
  };

  const pad2 = (n) => String(n).padStart(2, "0");
  const toYMD = (d) =>
    `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
  const parseYMD = (s) => {
    if (!s) return null;
    const [y, m, d] = String(s).slice(0, 10).split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
  };
  const addDaysYMD = (ymd, days) => {
    const base = parseYMD(ymd);
    if (!base) return "";
    const next = new Date(base);
    next.setDate(next.getDate() + (Number(days) || 0));
    return toYMD(next);
  };
  const formatPretty = (s) => {
    const d = parseYMD(s);
    if (!d) return "";
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(d);
  };

  const isoToFlagEmoji = (isoCode) => {
    if (!isoCode || isoCode.length !== 2) return "🌐";
    const codePoints = [...isoCode.toUpperCase()].map(
      (char) => 0x1f1e6 - 65 + char.charCodeAt(0),
    );
    return String.fromCodePoint(...codePoints);
  };

  const FlagImg = ({ countryName, size = 20 }) => {
    const code = iso2Map[countryName];
    const [imgError, setImgError] = useState(false);

    if (!code) {
      return <span style={{ fontSize: size, lineHeight: 1 }}>🌐</span>;
    }

    if (imgError) {
      return (
        <span
          style={{
            fontSize: size,
            lineHeight: 1,
            fontFamily:
              "Apple Color Emoji, Segoe UI Emoji, Noto Color Emoji, sans-serif",
          }}
        >
          {isoToFlagEmoji(code)}
        </span>
      );
    }

    return (
      <img
        src={`https://hatscripts.github.io/circle-flags/flags/${code.toLowerCase()}.svg`}
        width={size}
        height={size}
        alt={countryName}
        style={{
          objectFit: "cover",
          verticalAlign: "middle",
          flexShrink: 0,
          display: "inline-block",
          borderRadius: 999,
        }}
        onError={() => setImgError(true)}
      />
    );
  };

  const DatePicker = ({
    value,
    onChange,
    minDate,
    placeholder,
    name,
    disabled = false,
  }) => {
    const [open, setOpen] = useState(false);
    const [viewDate, setViewDate] = useState(
      () => parseYMD(value) || new Date(),
    );
    const [panelPlacement, setPanelPlacement] = useState("bottom"); // "bottom" | "top"
    const wrapRef = useRef(null);
    const panelRef = useRef(null);

    useEffect(() => {
      if (value) setViewDate(parseYMD(value) || new Date());
    }, [value]);

    useEffect(() => {
      if (!open) return undefined;

      const recalc = () => {
        const wrapEl = wrapRef.current;
        if (!wrapEl) return;
        const wrapRect = wrapEl.getBoundingClientRect();
        const viewportH = window.innerHeight || 0;
        const gap = 12;
        const panelH =
          panelRef.current?.getBoundingClientRect().height ||
          panelRef.current?.offsetHeight ||
          340;

        const spaceBelow = viewportH - wrapRect.bottom;
        const spaceAbove = wrapRect.top;

        if (spaceBelow >= panelH + gap) return setPanelPlacement("bottom");
        if (spaceAbove >= panelH + gap) return setPanelPlacement("top");
        return setPanelPlacement(spaceAbove > spaceBelow ? "top" : "bottom");
      };

      const raf = requestAnimationFrame(recalc);
      window.addEventListener("resize", recalc);
      window.addEventListener("scroll", recalc, true);
      return () => {
        cancelAnimationFrame(raf);
        window.removeEventListener("resize", recalc);
        window.removeEventListener("scroll", recalc, true);
      };
    }, [open]);

    useEffect(() => {
      if (!open) return undefined;
      const h = (e) => {
        if (wrapRef.current && !wrapRef.current.contains(e.target)) {
          setOpen(false);
        }
      };
      document.addEventListener("mousedown", h);
      return () => document.removeEventListener("mousedown", h);
    }, [open]);

    const min = parseYMD(minDate);
    const viewYear = viewDate.getFullYear();
    const viewMonth = viewDate.getMonth();
    const firstDay = new Date(viewYear, viewMonth, 1).getDay();
    const daysInMonth = new Date(viewYear, viewMonth + 1, 0).getDate();
    const cells = [];
    for (let i = 0; i < firstDay; i += 1) cells.push(null);
    for (let d = 1; d <= daysInMonth; d += 1) cells.push(d);
    while (cells.length % 7 !== 0) cells.push(null);

    const isDisabled = (d) => {
      if (!min || !d) return false;
      const t = new Date(viewYear, viewMonth, d).getTime();
      const m = new Date(
        min.getFullYear(),
        min.getMonth(),
        min.getDate(),
      ).getTime();
      return t < m;
    };

    const selectDate = (d) => {
      if (!d || isDisabled(d)) return;
      const next = toYMD(new Date(viewYear, viewMonth, d));
      onChange(next);
      setOpen(false);
    };

    const monthLabel = new Intl.DateTimeFormat("en-US", {
      month: "long",
      year: "numeric",
    }).format(new Date(viewYear, viewMonth, 1));

    const today = new Date();
    const isToday = (d) =>
      d &&
      viewYear === today.getFullYear() &&
      viewMonth === today.getMonth() &&
      d === today.getDate();

    const isSelected = (d) => {
      if (!d || !value) return false;
      const sel = parseYMD(value);
      return (
        sel &&
        sel.getFullYear() === viewYear &&
        sel.getMonth() === viewMonth &&
        sel.getDate() === d
      );
    };

    return (
      <div className="ti-date" ref={wrapRef}>
        {name && <input type="hidden" name={name} value={value || ""} />}
        <button
          type="button"
          disabled={disabled}
          className={`ti-date-input${open ? " is-open" : ""}`}
          onClick={() => {
            if (!disabled) setOpen((p) => !p);
          }}
        >
          <span className={`ti-date-value${value ? " is-set" : ""}`}>
            {value ? formatPretty(value) : placeholder}
          </span>
          <span className="ti-date-icon">
            <CiCalendar />
          </span>
        </button>
        {open && !disabled && (
          <div
            ref={panelRef}
            className={`ti-date-panel${
              panelPlacement === "top" ? " ti-date-panel--top" : ""
            }`}
          >
            <div className="ti-date-header">
              <button
                type="button"
                className="ti-date-nav"
                onClick={() =>
                  setViewDate(new Date(viewYear, viewMonth - 1, 1))
                }
              >
                {"<"}
              </button>
              <div className="ti-date-title">{monthLabel}</div>
              <button
                type="button"
                className="ti-date-nav"
                onClick={() =>
                  setViewDate(new Date(viewYear, viewMonth + 1, 1))
                }
              >
                {">"}
              </button>
            </div>
            <div className="ti-date-week">
              {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((d) => (
                <span key={d}>{d}</span>
              ))}
            </div>
            <div className="ti-date-grid">
              {cells.map((d, i) => (
                <button
                  key={`${d ?? "x"}-${i}`}
                  type="button"
                  className={`ti-date-cell${
                    d && isSelected(d) ? " is-selected" : ""
                  }${d && isToday(d) ? " is-today" : ""}${
                    d && isDisabled(d) ? " is-disabled" : ""
                  }`}
                  onClick={() => selectDate(d)}
                  disabled={!d || isDisabled(d)}
                >
                  {d || ""}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };

  const restrictedRelationIds = new Set(
    (mastersData?.relationList || [])
      .filter((r) => {
        const name = String(r.RelationName || "")
          .trim()
          .toLowerCase();
        return name.includes("self") || name.includes("spouse");
      })
      .map((r) => Number(r.RelationID)),
  );
  const spouseRelationIds = new Set([
    263, // Spouse
    ...(mastersData?.relationList || [])
      .filter((r) => {
        const name = String(r.RelationName || "")
          .trim()
          .toLowerCase();
        return name.includes("spouse");
      })
      .map((r) => Number(r.RelationID)),
  ]);
  const childRelationIds = new Set(
    (mastersData?.relationList || [])
      .filter((r) => {
        const name = String(r.RelationName || "")
          .trim()
          .toLowerCase();
        return (
          name.includes("child") ||
          name.includes("son") ||
          name.includes("daughter")
        );
      })
      .map((r) => Number(r.RelationID)),
  );
  const selfRelationName =
    (mastersData?.relationList || []).find(
      (r) =>
        String(r.RelationName || "")
          .trim()
          .toLowerCase() === "self" || Number(r.RelationID) === 69,
    )?.RelationName || "Self";

  const getAvailableRelations = (currentIndex) => {
    const selectedRestricted = new Set(
      (values.travellers || [])
        .filter((t, idx) => idx !== currentIndex)
        .map((t) => Number(t.relation) || 0)
        .filter((id) => id && restrictedRelationIds.has(id)),
    );

    return (mastersData?.relationList || []).filter(
      (r) =>
        !selectedRestricted.has(Number(r.RelationID)) ||
        Number(r.RelationID) ===
          Number(values.travellers?.[currentIndex]?.relation),
    );
  };

  useEffect(() => {
    if (!autoDateTrip) {
      lastManualDatesRef.current = {
        startDate: values.startDate || "",
        endDate: values.endDate || "",
      };
    }
  }, [autoDateTrip, values.startDate, values.endDate]);

  useEffect(() => {
    const prev = prevTripTypeRef.current;

    if (autoDateTrip && prev !== values.selectedTripType) {
      const durationValue =
        effectiveDurationOptions.find(
          (option) =>
            String(option.key) === String(values.numberOfDays || ""),
        )?.key ||
        effectiveDurationOptions[0]?.key ||
        "";
      if (
        durationValue &&
        String(values.numberOfDays || "") !== durationValue
      ) {
        setFieldValue("numberOfDays", String(durationValue), true);
      }
      const startDateValue = values.startDate || toYMD(new Date());
      if (!values.startDate) {
        setFieldValue("startDate", startDateValue, true);
      }
      syncAutoReturnDate(startDateValue, durationValue);
    }

    if (!autoDateTrip && (prev === "Student" || prev === "Annual Multi Trip")) {
      const { startDate, endDate } = lastManualDatesRef.current || {};
      setFieldValue("startDate", startDate || "", true);
      setFieldValue("endDate", endDate || "", true);
    }

    prevTripTypeRef.current = values.selectedTripType;
  }, [
    values.selectedTripType,
    values.numberOfDays,
    autoDateTrip,
    setFieldValue,
  ]);

  useEffect(() => {
    if (!autoDateTrip) return;
    const startDateValue = values.startDate || toYMD(new Date());
    if (
      !values.startDate &&
      String(values.startDate || "") !== startDateValue
    ) {
      setFieldValue("startDate", startDateValue, true);
    }
    const duration =
      Number(values.numberOfDays) ||
      Number(effectiveDurationOptions[0]?.key) ||
      0;
    if (
      !values.numberOfDays &&
      effectiveDurationOptions[0]?.key &&
      String(values.numberOfDays || "") !== effectiveDurationOptions[0].key
    ) {
      setFieldValue("numberOfDays", effectiveDurationOptions[0].key, true);
    }
    syncAutoReturnDate(startDateValue, duration);
  }, [
    autoDateTrip,
    values.startDate,
    values.numberOfDays,
    effectiveDurationOptions,
    setFieldValue,
  ]); // intentionally not depending on values.startDate

  useEffect(() => {
    if (values.selectedTripType !== "Student") return;
    if ((values.travellers || []).length <= 1) return;
    toast.warn("Student trip plan allows only 1 traveller");
    setFieldValue("travellers", (values.travellers || []).slice(0, 1), true);
  }, [values.selectedTripType, values.travellers?.length, setFieldValue]);

  useEffect(() => {
    if (!dropdownOpen) return undefined;
    const onDocDown = (e) => {
      if (!dropdownRef.current) return;
      if (dropdownRef.current.contains(e.target)) return;
      setDropdownOpen(false);
    };
    document.addEventListener("mousedown", onDocDown);
    return () => document.removeEventListener("mousedown", onDocDown);
  }, [dropdownOpen]);

  useEffect(() => {
    if (!openSelect.type) return undefined;
    const onDocDown = (e) => {
      if (e.target.closest(".ti-select")) return;
      setOpenSelect({ index: -1, type: "" });
    };
    document.addEventListener("mousedown", onDocDown);
    return () => document.removeEventListener("mousedown", onDocDown);
  }, [openSelect]);

  useEffect(() => {
    if (values.startDate && values.endDate && !autoDateTrip) {
      const start = new Date(values.startDate),
        end = new Date(values.endDate);
      if (start > end) {
        setFieldValue("endDate", null, true);
        setFieldValue("numberOfDays", null, true);
        setErrors({ ...errors, endDate: "End date is required." });
      } else {
        const diff = end - start + 86400000;
        setFieldValue("numberOfDays", Math.floor(diff / 86400000), true);
      }
    }
  }, [
    values.startDate,
    values.endDate,
    autoDateTrip,
    setFieldValue,
    setErrors,
    errors,
  ]);

  useEffect(() => {
    setInitialValues((pState) => ({
      ...pState,
      destination: travellerDetails.destination,
      mobileNo: travellerDetails.mobileNo,
      selectedTripType: travellerDetails.tripType,
      numberOfDays: travellerDetails.numberOfDays,
      startDate: travellerDetails.startDate,
      endDate: travellerDetails.endDate,
      travellers: (travellerDetails.travellers || []).map((traveller) => ({
        ...traveller,
        dob: traveller?.dob || getDobFromAge(traveller?.age),
      })),
    }));
  }, []);

  const normalizedCountries = (mastersData?.countryList || []).map((c) => ({
    ...c,
    label: c.CountryName ?? c.label,
    value: c.Id ?? c.value,
  }));
  const normalizedPopular = (mastersData?.popularCountries || []).map((c) => ({
    ...c,
    label: c.CountryName ?? c.label,
    value: c.Id ?? c.value,
  }));

  const selectedCountries = Array.isArray(values.destination)
    ? values.destination
    : [];

  const filteredCountries = normalizedCountries.filter(
    (c) =>
      String(c.CountryName || "")
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) &&
      !selectedCountries.some((s) => String(s.Id) === String(c.Id)),
  );

  const toggleCountry = (c) => {
    setFieldTouched("destination", true, true);
    const exists = selectedCountries.some((s) => String(s.Id) === String(c.Id));
    const next = exists
      ? selectedCountries.filter((s) => String(s.Id) !== String(c.Id))
      : [...selectedCountries, c];
    setFieldValue("destination", next, true);
    setSearchQuery("");
  };

  const handleAddTraveller = () => {
    if (values.selectedTripType === "Student") {
      toast.warn("Student trip plan allows only 1 traveller");
      return;
    }
    if ((values.travellers || []).length >= MAX_MEMBERS) {
      toast.warn("Maximum 4 travellers are allowed");
      return;
    }
    addTraveller();
  };

  const submitDetails = async () => {
    const normalizedTravellers = (values.travellers || []).map((traveller) => ({
      ...traveller,
      dob: traveller?.dob || getDobFromAge(traveller?.age),
    }));
    const refreshPromise = updateDetails({
      destination: values.destination,
      mobileNo: values.mobileNo,
      startDate: values.startDate,
      endDate: values.endDate,
      numberOfDays: values.numberOfDays,
      travellers: normalizedTravellers,
      tripType: values.selectedTripType,
    });
    closeModal(false);
    return refreshPromise;
  };

  const handleUpdateClick = async () => {
    if (isSubmitting) return;
    const destinationCount = Array.isArray(values.destination)
      ? values.destination.length
      : 0;
    const travellerCount = Array.isArray(values.travellers)
      ? values.travellers.length
      : 0;
    const mobileDigits = String(values.mobileNo || "").replace(/\D/g, "");

    if (destinationCount === 0) {
      toast.error("Destination is required");
      return;
    }
    if (mobileDigits.length !== 10) {
      toast.error("Enter a valid 10-digit mobile number");
      return;
    }
    if (!values.selectedTripType) {
      toast.error("Trip type is required");
      return;
    }
    if (!values.startDate || !values.endDate) {
      toast.error("Travel dates are required");
      return;
    }
    if (travellerCount === 0) {
      toast.error("At least one traveller is required");
      return;
    }

    const hasEmptyTraveller = (values.travellers || []).some(
      (traveller) =>
        traveller == null ||
        String(traveller.age ?? "").trim() === "" ||
        String(traveller.relation ?? "").trim() === "",
    );
    if (hasEmptyTraveller) {
      toast.error("Please complete all traveller details");
      return;
    }

    try {
      await submitDetails();
    } catch (error) {
      toast.error(error?.message || "Failed to update details");
    }
  };

  const tripTypeList = [
    { key: "single", value: "Single" },
    { key: "annualMultiTrip", value: "Annual Multi Trip" },
    { key: "student", value: "Student" },
  ];

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Barlow:wght@400;500;600;700&display=swap');

        /* ── Modal shell ── */
        .edf-modal .modal-dialog,
        .CustomeModal .modal-dialog {
          max-width: 500px;
          margin: 40px auto;
        }
        .edf-modal .modal-content,
        .CustomeModal .modal-content {
          border: none !important;
          border-radius: 18px !important;
          box-shadow: 0 24px 80px rgba(10,28,18,0.22), 0 4px 16px rgba(10,28,18,0.10) !important;
          overflow: hidden;
          font-family: 'Barlow', sans-serif;
          animation: edf-up 0.22s cubic-bezier(0.34,1.2,0.64,1);
        }
        @keyframes edf-up {
          from { opacity: 0; transform: translateY(14px) scale(0.98); }
          to   { opacity: 1; transform: translateY(0) scale(1); }
        }

        /* ── Header ── */
        .edf-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 16px 20px 14px;
          border-bottom: 1px solid rgba(27,94,60,0.09);
          background: #fff;
          flex-shrink: 0;
        }
        .edf-header-left {
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .edf-header-icon {
          width: 32px; height: 32px;
          border-radius: 8px;
          background: #f2fbf6;
          border: 1px solid rgba(27,94,60,0.14);
          display: flex; align-items: center; justify-content: center;
          flex-shrink: 0;
        }
        .edf-header-icon svg { width: 15px; height: 15px; }
        .edf-title {
          font-size: 15px;
          font-weight: 700;
          color: #0d2b1e;
          letter-spacing: -0.01em;
        }
        .edf-close-btn {
          width: 30px; height: 30px;
          border-radius: 8px;
          border: 1px solid rgba(27,94,60,0.12);
          background: transparent;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          color: #5a7a68;
          transition: background 0.16s ease, color 0.16s ease, border-color 0.16s ease;
        }
        .edf-close-btn:hover { background: var(--brand-primary-deep); color: #fff; border-color: var(--brand-primary-deep); }
        .edf-close-btn svg { width: 13px; height: 13px; }

        /* ── Scrollable body ── */
        .edf-body {
          overflow-y: auto;
          max-height: 70vh;
          padding: 18px 20px;
          display: flex;
          flex-direction: column;
          gap: 16px;
          background: #fff;
        }
        .edf-body::-webkit-scrollbar { width: 4px; }
        .edf-body::-webkit-scrollbar-thumb { background: rgba(27,94,60,0.15); border-radius: 10px; }

        /* ── Section ── */
        .edf-section { display: flex; flex-direction: column; gap: 6px; }
        .edf-section--dest { position: relative; }
        .edf-label {
          font-size: 9.5px;
          font-weight: 700;
          letter-spacing: 0.12em;
          text-transform: uppercase;
          color: #8aab97;
        }
        .edf-hint {
          font-size: 10.5px;
          color: #8aab97;
          font-weight: 400;
          margin-top: 2px;
        }

        /* ── Field error ── */
        .edf-error {
          font-size: 10.5px;
          color: #dc3545;
          font-weight: 500;
          margin-top: 2px;
          display: flex;
          align-items: center;
          gap: 4px;
        }

        /* ── Input / Select ── */
        .edf-input, .edf-select {
          width: 100%;
          height: 40px;
          border: 1.5px solid rgba(27,94,60,0.18);
          border-radius: 8px;
          padding: 0 12px;
          font-family: 'Barlow', sans-serif;
          font-size: 13px;
          font-weight: 500;
          color: #0d2b1e;
          background: #fff;
          outline: none;
          transition: border 0.18s ease, box-shadow 0.18s ease;
          appearance: none;
          -webkit-appearance: none;
        }
        .edf-input:focus, .edf-select:focus {
          border-color: var(--brand-primary-deep);
          box-shadow: 0 0 0 3px rgba(26,82,54,0.08);
        }
        .edf-input.has-error, .edf-select.has-error { border-color: #dc3545; }
        .edf-input::placeholder { color: #8aab97; }
        .edf-select {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%238aab97' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 12px center;
          cursor: pointer;
        }

        /* ── Trip type toggle ── */
        .edf-trip-btns {
          display: flex;
          gap: 6px;
          flex-wrap: wrap;
        }
        .edf-trip-btn {
          flex: 1;
          min-width: 80px;
          border: 1.5px solid rgba(27,94,60,0.16);
          border-radius: 8px;
          padding: 7px 10px;
          font-family: 'Barlow', sans-serif;
          font-size: 12px;
          font-weight: 600;
          color: #5a7a68;
          background: #fff;
          cursor: pointer;
          text-align: center;
          transition: all 0.18s ease;
        }
        .edf-trip-btn:hover { border-color: var(--brand-primary-deep); color: var(--brand-primary-deep); background: #f2fbf6; }
        .edf-trip-btn.active {
          background: var(--brand-primary-deep);
          border-color: var(--brand-primary-deep);
          color: #fff;
          box-shadow: 0 2px 8px rgba(26,82,54,0.20);
        }

        /* ── Date grid ── */
        .edf-date-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }
        .edf-date-col { display: flex; flex-direction: column; gap: 4px; }
        .edf-date-inner-label {
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.10em;
          text-transform: uppercase;
          color: #8aab97;
          margin-bottom: 1px;
        }

        /* ── Duration pill ── */
        .edf-duration-pill {
          display: inline-flex;
          align-items: center;
          gap: 5px;
          background: #f2fbf6;
          border: 1px solid rgba(27,94,60,0.14);
          border-radius: 20px;
          padding: 4px 12px;
          font-size: 11px;
          font-weight: 600;
          color: var(--brand-primary-deep);
          margin-top: 4px;
          width: fit-content;
        }
        .edf-duration-pill svg { width: 11px; height: 11px; }

        /* ── Traveller cards ── */
        .edf-travellers { display: flex; flex-direction: column; gap: 8px; }
        .edf-traveller-card {
          background: #fafcfb;
          border: 1px solid rgba(27,94,60,0.09);
          border-radius: 10px;
          padding: 12px 14px;
        }
        .edf-traveller-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 10px;
        }
        .edf-traveller-num {
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 0.10em;
          text-transform: uppercase;
          color: #8aab97;
        }
        .edf-remove-btn {
          width: 22px; height: 22px;
          border-radius: 6px;
          border: 1px solid rgba(27,94,60,0.12);
          background: transparent;
          display: flex; align-items: center; justify-content: center;
          cursor: pointer;
          color: #8aab97;
          transition: all 0.16s ease;
        }
        .edf-remove-btn:hover { background: #dc3545; color: #fff; border-color: #dc3545; }
        .edf-remove-btn svg { width: 11px; height: 11px; }
        .edf-traveller-fields {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 10px;
        }
        .edf-traveller-fields.single-col { grid-template-columns: 1fr; }
        .edf-field-group { display: flex; flex-direction: column; gap: 3px; }
        .edf-field-label {
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.10em;
          text-transform: uppercase;
          color: #8aab97;
        }

        /* ── Add traveller ── */
        .edf-add-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          width: 100%;
          border: 1.5px dashed rgba(27,94,60,0.22);
          border-radius: 9px;
          background: transparent;
          padding: 9px;
          font-family: 'Barlow', sans-serif;
          font-size: 12px;
          font-weight: 600;
          color: var(--brand-primary-deep);
          cursor: pointer;
          transition: background 0.18s ease, border-color 0.18s ease;
        }
        .edf-add-btn:hover { background: #f2fbf6; border-color: var(--brand-primary-deep); }
        .edf-add-btn svg { width: 13px; height: 13px; }

        /* ── Footer ── */
        .edf-footer {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 10px;
          padding: 14px 20px;
          border-top: 1px solid rgba(27,94,60,0.08);
          background: #fafcfb;
          flex-shrink: 0;
        }
        .edf-cancel-btn {
          border: 1.5px solid rgba(27,94,60,0.16);
          background: transparent;
          border-radius: 8px;
          padding: 8px 18px;
          font-family: 'Barlow', sans-serif;
          font-size: 12px;
          font-weight: 600;
          color: #5a7a68;
          cursor: pointer;
          transition: all 0.18s ease;
        }
        .edf-cancel-btn:hover { background: rgba(27,94,32,0.06); color: var(--brand-primary-deep); border-color: var(--brand-primary-deep); }

        /* Override SubmitButton / TraveL-BTN styles */
        .edf-footer .TraveL-BTN,
        .edf-submit-btn {
          border: none !important;
          background: var(--brand-primary-deep) !important;
          border-radius: 8px !important;
          padding: 9px 24px !important;
          font-family: 'Barlow', sans-serif !important;
          font-size: 12px !important;
          font-weight: 700 !important;
          color: #fff !important;
          cursor: pointer !important;
          transition: background 0.18s ease, box-shadow 0.18s ease, transform 0.18s ease !important;
          box-shadow: 0 2px 10px rgba(26,82,54,0.22) !important;
          letter-spacing: 0.02em !important;
          opacity: 1 !important;
        }
        .edf-footer .TraveL-BTN:hover,
        .edf-submit-btn:hover {
          background: var(--brand-primary-forest) !important;
          box-shadow: 0 4px 16px rgba(26,82,54,0.30) !important;
          transform: translateY(-1px) !important;
        }
        .edf-footer .TraveL-BTN:disabled,
        .edf-submit-btn:disabled {
          background: rgba(27,94,60,0.25) !important;
          box-shadow: none !important;
          transform: none !important;
          cursor: not-allowed !important;
        }

        /* CommonDropdown / MobileMaskedInput overrides */
        .edf-traveller-card .textdemo,
        .edf-section .textdemo {
          width: 100% !important;
          height: 40px !important;
          border: 1.5px solid rgba(27,94,60,0.18) !important;
          border-radius: 8px !important;
          padding: 0 12px !important;
          font-family: 'Barlow', sans-serif !important;
          font-size: 13px !important;
          font-weight: 500 !important;
          color: #0d2b1e !important;
          background: #fff !important;
          outline: none !important;
          box-shadow: none !important;
          appearance: none !important;
          -webkit-appearance: none !important;
        }
        .edf-traveller-card .textdemo:focus,
        .edf-section .textdemo:focus {
          border-color: var(--brand-primary-deep) !important;
          box-shadow: 0 0 0 3px rgba(26,82,54,0.08) !important;
        }
        .edf-traveller-card .demo-label,
        .edf-section .demo-label { display: none !important; }
        .edf-traveller-card .error-message,
        .edf-section .error-message {
        position:absolute;
          font-family: 'Barlow', sans-serif !important;
          font-size: 10.5px !important;
          color: #dc3545 !important;
          font-weight: 500 !important;
          margin-top: 1px !important;
          display: block !important;
        }

        /* ── HomePage-like UI (scoped to this modal) ── */
        .edf-root {
          --edf-green: var(--brand-primary-deep);
          --edf-muted: #8aab97;
          --edf-border: rgba(27,94,60,0.18);
          --edf-soft: #f2fbf6;
          position: relative;
        }

        .edf-root .ti-multiselect {
          position: relative;
          display: flex;
          align-items: flex-start;
          gap: 6px;
          padding: 8px 10px;
          border-radius: 10px;
          border: 1.5px solid var(--edf-border);
          background: #fff;
          cursor: text;
          min-height: 40px;
          transition: border 0.18s, box-shadow 0.18s, background 0.18s;
        }
        .edf-root .ti-multiselect.is-open,
        .edf-root .ti-multiselect:focus-within {
          border-color: var(--edf-green);
          box-shadow: 0 0 0 3px rgba(26,82,54,0.08);
        }
        .edf-root .ti-tags {
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
          flex: 1;
          align-items: center;
        }
        .edf-root .ti-tag {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: var(--edf-soft);
          border: 1px solid rgba(27,94,60,0.14);
          border-radius: 999px;
          padding: 3px 10px 3px 8px;
          font-size: 11px;
          font-weight: 700;
          color: var(--edf-green);
          white-space: nowrap;
        }
        .edf-root .ti-tag-x {
          background: none;
          border: none;
          cursor: pointer;
          color: #5a7a68;
          line-height: 0;
          padding: 0;
        }
        .edf-root .ti-tag-x:hover { color: var(--edf-green); }
        .edf-root .ti-tag-input {
          border: none;
          outline: none;
          background: transparent;
          font-family: 'Barlow', sans-serif;
          font-size: 13px;
          color: #0d2b1e;
          min-width: 140px;
          flex: 1;
        }
        .edf-root .ti-tag-input::placeholder { color: var(--edf-muted); }
        .edf-root .ti-chevron {
          font-size: 9px;
          color: var(--edf-muted);
          margin-left: 4px;
          flex-shrink: 0;
          align-self: center;
        }
        .edf-root .ti-count { font-size: 10.5px; color: var(--edf-green); font-weight: 700; }

        .edf-root .ti-popular { margin-top: 10px; }
        .edf-root .ti-popular-title {
          font-size: 9px;
          font-weight: 800;
          color: var(--edf-muted);
          letter-spacing: 0.6px;
          text-transform: uppercase;
          margin-bottom: 6px;
        }
        .edf-root .ti-popular-list { display: flex; flex-wrap: wrap; gap: 6px; }
        .edf-root .ti-skeleton-chip {
          height: 26px;
          width: 96px;
          border-radius: 999px;
          background: linear-gradient(90deg, #eaf5ee 0%, #f6fbf7 45%, #eaf5ee 100%);
          background-size: 200% 100%;
          animation: ti-skeleton 1.2s ease-in-out infinite;
        }
        @keyframes ti-skeleton {
          0% { background-position: 0% 0%; }
          100% { background-position: 200% 0%; }
        }
        .edf-root .ti-popular-chip {
          border: 1px solid rgba(27,94,60,0.14);
          background: #fff;
          color: #0d2b1e;
          border-radius: 999px;
          padding: 5px 10px;
          font-size: 11px;
          font-weight: 700;
          display: inline-flex;
          align-items: center;
          gap: 7px;
          cursor: pointer;
          transition: background 0.15s, border 0.15s, transform 0.12s;
        }
        .edf-root .ti-popular-chip:hover {
          background: rgba(27,94,60,0.06);
          border-color: rgba(27,94,60,0.24);
          transform: translateY(-1px);
        }
        .edf-root .ti-popular-chip.is-selected {
          background: var(--edf-green);
          color: #fff;
          border-color: var(--edf-green);
          box-shadow: 0 6px 16px rgba(26,82,54,0.18);
        }

        .edf-root .ti-dropdown {
          position: absolute;
          top: calc(30% + 8px);
          left: 0;
          right: 0;
          background: #fff;
          border-radius: 12px;
          border: 1px solid rgba(27,94,60,0.14);
          box-shadow: 0 18px 55px rgba(15, 40, 28, 0.18);
          z-index: 2000;
          max-height: 220px;
          overflow-y: auto;
        }
        .edf-root .ti-dropdown-empty {
          padding: 14px;
          text-align: center;
          font-size: 12px;
          color: var(--edf-muted);
        }
        .edf-root .ti-option {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 10px 12px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          border-radius: 10px;
          margin: 4px;
          transition: background 0.12s;
          color: #0d2b1e;
        }
        .edf-root .ti-option:hover { background: rgba(27,94,60,0.06); }
        .edf-root .ti-option.is-selected { background: rgba(27,94,60,0.08); color: var(--edf-green); }
        .edf-root .ti-tick { margin-left: auto; color: var(--edf-green); font-weight: 900; font-size: 12px; }

        .edf-root .ti-select { position: relative; }
        .edf-root .ti-select-btn {
          width: 100%;
          min-height: 40px;
          border-radius: 8px;
          border: 1.5px solid var(--edf-border);
          background: #fff;
          padding: 9px 12px;
          font-size: 13px;
          font-weight: 600;
          color: #0d2b1e;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          transition: border 0.15s, box-shadow 0.15s, background 0.15s;
        }
        .edf-root .ti-select-btn.is-open {
          border-color: var(--edf-green);
          box-shadow: 0 0 0 3px rgba(26,82,54,0.08);
        }
        .edf-root .ti-select-caret { font-size: 9px; color: var(--edf-muted); }
        .edf-root .ti-select-menu {
          position: absolute;
          top: calc(100% + 6px);
          left: 0;
          right: 0;
          background: #fff;
          border: 1px solid rgba(27,94,60,0.14);
          border-radius: 12px;
          box-shadow: 0 18px 55px rgba(15, 40, 28, 0.18);
          padding: 6px;
          z-index: 2500;
          max-height: 180px;
          overflow: auto;
        }
        .edf-root .ti-select-item {
          width: 100%;
          text-align: left;
          border: none;
          background: #fff;
          padding: 9px 10px;
          border-radius: 10px;
          font-size: 13px;
          font-weight: 600;
          color: #0d2b1e;
          cursor: pointer;
        }
        .edf-root .ti-select-item:hover { background: rgba(27,94,60,0.06); }
        .edf-root .ti-select-item.is-selected { background: rgba(27,94,60,0.10); color: var(--edf-green); }

        .edf-root .ti-date { position: relative; }
        .edf-root .ti-date-input {
          width: 100%;
          padding: 9px 12px;
          border-radius: 8px;
          border: 1.5px solid var(--edf-border);
          background: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
          color: #0d2b1e;
          cursor: pointer;
          font-family: 'Barlow', sans-serif;
          font-size: 13px;
          transition: box-shadow 0.18s, transform 0.18s, background 0.18s, border 0.18s;
        }
        .edf-root .ti-date-input:hover { transform: translateY(-1px); }
        .edf-root .ti-date-input.is-open {
          border-color: var(--edf-green);
          box-shadow: 0 0 0 3px rgba(26,82,54,0.08);
        }
        .edf-root .ti-date-value { color: var(--edf-muted); font-weight: 600; }
        .edf-root .ti-date-value.is-set { color: #0d2b1e; }
        .edf-root .ti-date-icon { width: 26px; height: 26px; color: var(--edf-green); display: inline-flex; align-items: center; justify-content: center; font-size: 18px; }
        .edf-root .ti-date-panel {
          position: absolute;
          top: calc(100% + 8px);
          left: 0;
          right: 0;
          background: #fff;
          border-radius: 14px;
          border: 1px solid rgba(27,94,60,0.14);
          box-shadow: 0 18px 55px rgba(15, 40, 28, 0.18);
          padding: 12px;
          z-index: 2500;
        }
        .edf-root .ti-date-panel.ti-date-panel--top { top: auto; bottom: calc(100% + 8px); }
        .edf-root .ti-date-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
        .edf-root .ti-date-title { font-size: 12px; font-weight: 800; color: #0d2b1e; }
        .edf-root .ti-date-nav {
          width: 28px; height: 28px; border-radius: 8px;
          border: 1px solid rgba(27,94,60,0.14);
          background: var(--edf-soft);
          color: var(--edf-green);
          font-weight: 800;
          cursor: pointer;
        }
        .edf-root .ti-date-week {
          display: grid;
          grid-template-columns: repeat(7, 1fr);
          gap: 4px;
          margin-bottom: 6px;
          font-size: 9px;
          color: var(--edf-muted);
          text-align: center;
          letter-spacing: 0.6px;
          text-transform: uppercase;
        }
        .edf-root .ti-date-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 4px; }
        .edf-root .ti-date-cell {
          height: 30px;
          border-radius: 8px;
          border: 1px solid transparent;
          background: #f6fbf7;
          color: #0d2b1e;
          font-size: 11px;
          font-weight: 800;
          cursor: pointer;
          transition: background 0.12s, border 0.12s, transform 0.12s;
        }
        .edf-root .ti-date-cell:hover:not(:disabled) { background: rgba(27,94,60,0.06); transform: translateY(-1px); }
        .edf-root .ti-date-cell.is-today { border-color: rgba(27,94,60,0.35); }
        .edf-root .ti-date-cell.is-selected { background: var(--edf-green); color: #fff; box-shadow: 0 6px 14px rgba(26,82,54,0.18); }
        .edf-root .ti-date-cell.is-disabled { opacity: 0.35; cursor: not-allowed; background: #f1f5f2; }

        @media (max-width: 560px) {
          .edf-date-grid { grid-template-columns: 1fr; }
          .edf-traveller-fields { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="edf-root">
        {/* Header */}
        <div className="edf-header">
          <div className="edf-header-left">
            <div className="edf-header-icon">
              <svg
                fill="none"
                stroke="var(--brand-primary-deep)"
                strokeWidth="1.8"
                viewBox="0 0 20 20"
              >
                <path
                  d="M14 2l4 4-9 9H5v-4L14 2z"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <span className="edf-title">Edit Details</span>
          </div>
          <button
            className="edf-close-btn"
            onClick={() => closeModal(false)}
            aria-label="Close"
            type="button"
          >
            <svg
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 16 16"
            >
              <path d="M3 3l10 10M13 3L3 13" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        {/* Body */}
        <div className="edf-body">
          {/* Destination */}
          <div className="edf-section edf-section--dest" ref={dropdownRef}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "baseline",
              }}
            >
              <span className="edf-label">Destination</span>
              {selectedCountries.length > 0 && (
                <span className="ti-count">
                  {selectedCountries.length} selected
                </span>
              )}
            </div>

            <div
              className={`ti-multiselect${dropdownOpen ? " is-open" : ""}`}
              onClick={() => setDropdownOpen(true)}
            >
              <div className="ti-tags">
                {selectedCountries.map((c) => (
                  <span key={c.Id} className="ti-tag">
                    <FlagImg countryName={c.CountryName} size={16} />
                    <span>{c.CountryName}</span>
                    <button
                      className="ti-tag-x"
                      type="button"
                      onClick={(e) => {
                        e.stopPropagation();
                        toggleCountry(c);
                      }}
                      aria-label={`Remove ${c.CountryName}`}
                    >
                      <RxCross1 size={10} />
                    </button>
                  </span>
                ))}
                <input
                  name="destinationSearch"
                  className="ti-tag-input"
                  placeholder={
                    selectedCountries.length === 0
                      ? "Search & select destinations..."
                      : "Add more..."
                  }
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setDropdownOpen(true);
                  }}
                  onFocus={() => setDropdownOpen(true)}
                />
              </div>
              <span className="ti-chevron">
                {dropdownOpen ? (
                  <MdArrowDropUp size={15} />
                ) : (
                  <IoMdArrowDropdown size={15} />
                )}
              </span>
            </div>

            {popularLoading && (
              <div className="ti-popular">
                <div className="ti-popular-title">Popular countries</div>
                <div className="ti-popular-list">
                  {Array.from({ length: 8 }).map((_, i) => (
                    <div key={i} className="ti-skeleton-chip" />
                  ))}
                </div>
              </div>
            )}

            {!popularLoading && normalizedPopular.length > 0 && (
              <div className="ti-popular">
                <div className="ti-popular-title">Popular countries</div>
                <div className="ti-popular-list">
                  {normalizedPopular.map((c) => (
                    <button
                      key={c.Id}
                      type="button"
                      className={`ti-popular-chip${
                        selectedCountries.some(
                          (s) => String(s.Id) === String(c.Id),
                        )
                          ? " is-selected"
                          : ""
                      }`}
                      onClick={() => toggleCountry(c)}
                    >
                      <FlagImg countryName={c.CountryName} size={14} />
                      <span>{c.CountryName}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}

            {dropdownOpen && (
              <div className="ti-dropdown">
                {filteredCountries.length === 0 ? (
                  <p className="ti-dropdown-empty">No countries found</p>
                ) : (
                  filteredCountries.map((c) => (
                    <div
                      key={c.Id}
                      className={`ti-option${
                        selectedCountries.some(
                          (s) => String(s.Id) === String(c.Id),
                        )
                          ? " is-selected"
                          : ""
                      }`}
                      onMouseDown={(e) => {
                        e.preventDefault();
                        toggleCountry(c);
                      }}
                    >
                      <FlagImg countryName={c.CountryName} size={18} />
                      <span>{c.CountryName}</span>
                      {selectedCountries.some(
                        (s) => String(s.Id) === String(c.Id),
                      ) && <span className="ti-tick">✓</span>}
                    </div>
                  ))
                )}
              </div>
            )}

            {errors.destination && touched.destination && (
              <span className="edf-error">⚠ {errors.destination}</span>
            )}
            <span className="edf-hint">Point of origin should be India</span>
          </div>

          {/* Trip Type */}
          <div className="edf-section">
            <span className="edf-label">Trip Plan</span>
            <div className="edf-trip-btns">
              {tripTypeList?.map((item) => (
                <button
                  key={item.value}
                  type="button"
                  className={`edf-trip-btn${values.selectedTripType === item.value ? " active" : ""}`}
                  onClick={() => handleTripTypeChange(item.value)}
                >
                  {item.value}
                </button>
              ))}
            </div>
          </div>

          {/* Duration (Student / Annual Multi Trip) */}
          {autoDateTrip && (
            <div className="edf-section">
              <span className="edf-label">Duration of Trips</span>
              <select
                className="edf-select"
                value={values.numberOfDays ?? ""}
                onChange={(e) => {
                  setFieldTouched("numberOfDays", true, true);
                  const nextDays = e.target.value;
                  setFieldValue("numberOfDays", nextDays, true);
                  syncAutoReturnDate(values.startDate, nextDays);
                }}
              >
                <option value="" disabled>
                  Select duration
                </option>
                {effectiveDurationOptions.map((opt) => (
                  <option key={opt.key} value={opt.key}>
                    {opt.value}
                  </option>
                ))}
              </select>
              {Number(values.numberOfDays) > 0 && (
                <div className="edf-duration-pill">
                  <svg
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 16 16"
                  >
                    <circle cx="8" cy="8" r="6.5" />
                    <path d="M8 5v3.5l2 2" strokeLinecap="round" />
                  </svg>
                  Duration: {Number(values.numberOfDays)} days
                </div>
              )}
            </div>
          )}

          {/* Dates */}
          <div className="edf-section">
            <span className="edf-label">Travel Dates</span>
            <div className="edf-date-grid">
              <div className="edf-date-col">
                <span className="edf-date-inner-label">Departure</span>
                <DatePicker
                  name="startDate"
                  value={values.startDate || ""}
                  minDate={toYMD(new Date())}
                  placeholder="DD/MM/YYYY"
                  onChange={(v) => {
                    setFieldTouched("startDate", true, true);
                    setFieldValue("startDate", v, true);
                    if (autoDateTrip) {
                      syncAutoReturnDate(v, values.numberOfDays);
                    } else if (values.endDate && v > values.endDate) {
                      setFieldValue("endDate", "", true);
                      setFieldValue("numberOfDays", null, true);
                    }
                  }}
                />
                {errors.startDate && touched.startDate && (
                  <span className="edf-error">⚠ {errors.startDate}</span>
                )}
              </div>
              <div className="edf-date-col">
                <span className="edf-date-inner-label">Return</span>
                <DatePicker
                  name="endDate"
                  value={values.endDate || ""}
                  minDate={values.startDate || toYMD(new Date())}
                  placeholder="DD/MM/YYYY"
                  disabled={autoDateTrip}
                  onChange={(v) => {
                    if (!autoDateTrip) {
                      setFieldTouched("endDate", true, true);
                      setFieldValue("endDate", v, true);
                    }
                  }}
                />
                {errors.endDate && touched.endDate && (
                  <span className="edf-error">⚠ {errors.endDate}</span>
                )}
              </div>
            </div>
            {Number(values.numberOfDays) > 0 && (
              <div className="edf-duration-pill">
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 16 16"
                >
                  <circle cx="8" cy="8" r="6.5" />
                  <path d="M8 5v3.5l2 2" strokeLinecap="round" />
                </svg>
                Trip duration: {Number(values.numberOfDays)} days
              </div>
            )}
          </div>

          {/* Mobile */}
          <div className="edf-section">
            <span className="edf-label">Mobile Number</span>
            <MobileMaskedInput
              name="mobileNo"
              value={values.mobileNo}
              onChange={(e) => setFieldValue("mobileNo", e.target.value, true)}
              onBlur={() => setFieldTouched("mobileNo", true, true)}
              error={errors.mobileNo}
              touched={touched.mobileNo}
            />
          </div>

          {/* Travellers */}
          <div className="edf-section">
            <span className="edf-label">Traveller Details</span>
            <div className="edf-travellers">
              {values.travellers?.map((traveller, index) => (
                <div key={index} className="edf-traveller-card">
                  <div className="edf-traveller-head">
                    <span className="edf-traveller-num">
                      Traveller {index + 1}
                    </span>
                    {values.travellers.length > 1 && index !== 0 && (
                      <button
                        className="edf-remove-btn"
                        type="button"
                        onClick={() => removeTraveller(index)}
                      >
                        <svg
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          viewBox="0 0 16 16"
                        >
                          <path
                            d="M3 3l10 10M13 3L3 13"
                            strokeLinecap="round"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  <div
                    className={`edf-traveller-fields${
                      values.travellers?.length === 1 ? " single-col" : ""
                    }`}
                  >
                    {/* Age */}
                    <div className="edf-field-group">
                      <span className="edf-field-label">Age (years)</span>
                      <div className="ti-select">
                        <button
                          type="button"
                          className={`ti-select-btn${
                            openSelect.index === index &&
                            openSelect.type === "age"
                              ? " is-open"
                              : ""
                          }`}
                          onClick={() =>
                            setOpenSelect((p) =>
                              p.index === index && p.type === "age"
                                ? { index: -1, type: "" }
                                : { index, type: "age" },
                            )
                          }
                        >
                          <span>
                            {traveller.age
                              ? mastersData?.ageList?.find(
                                  (a) =>
                                    String(a.AgeValue) ===
                                    String(traveller.age),
                                )?.AgeText || "Select"
                              : "Select"}
                          </span>
                          <span className="ti-select-caret">
                            {openSelect.index === index &&
                            openSelect.type === "age" ? (
                              <MdArrowDropUp />
                            ) : (
                              <IoMdArrowDropdown />
                            )}
                          </span>
                        </button>
                        {openSelect.index === index &&
                          openSelect.type === "age" && (
                            <div className="ti-select-menu">
                              {(mastersData?.ageList || []).map((a) => (
                                <button
                                  type="button"
                                  key={a.AgeValue}
                                  className={`ti-select-item${
                                    String(traveller.age) === String(a.AgeValue)
                                      ? " is-selected"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    const ageField = `travellers[${index}].age`;
                                    const nextAge =
                                      Number(a.AgeValue) || a.AgeValue;

                                    const relId =
                                      Number(
                                        values.travellers?.[index]?.relation,
                                      ) || 0;
                                    const nextAgeNum = Number(nextAge);
                                    if (
                                      Number.isFinite(nextAgeNum) &&
                                      nextAgeNum < MIN_ADULT_AGE
                                    ) {
                                      if (index === 0) {
                                        toast.error(
                                          "Member 1 age must be 18 or above",
                                        );
                                        return;
                                      }
                                      if (
                                        relId &&
                                        spouseRelationIds.has(relId)
                                      ) {
                                        toast.error(
                                          "Spouse age must be 18 or above",
                                        );
                                        return;
                                      }
                                      const adultExists = (
                                        values.travellers || []
                                      ).some((t, i) => {
                                        if (i === index) return false;
                                        const aa = Number(t.age);
                                        return (
                                          Number.isFinite(aa) &&
                                          aa >= MIN_ADULT_AGE
                                        );
                                      });
                                      if (!adultExists) {
                                        toast.error("Add an adult (18+) first");
                                        return;
                                      }
                                      const otherChildrenCount = (
                                        values.travellers || []
                                      ).filter((t, i) => {
                                        if (i === index) return false;
                                        const aa = Number(t.age);
                                        return (
                                          Number.isFinite(aa) &&
                                          aa < MIN_ADULT_AGE
                                        );
                                      }).length;
                                      if (otherChildrenCount >= MAX_CHILDREN) {
                                        toast.error(
                                          "Maximum 2 children allowed",
                                        );
                                        return;
                                      }
                                    }

                                    setFieldValue(ageField, nextAge, true);
                                    setFieldValue(
                                      `travellers[${index}].dob`,
                                      getDobFromAge(nextAge),
                                      true,
                                    );
                                    setFieldTouched(ageField, true, false);
                                    setTimeout(
                                      () => validateField(ageField),
                                      0,
                                    );

                                    if (index === 0) {
                                      const selfId =
                                        mastersData?.relationList?.find(
                                          (r) =>
                                            String(r.RelationName || "")
                                              .trim()
                                              .toLowerCase() === "self",
                                        )?.RelationID || null;

                                      const relationField = `travellers[${index}].relation`;
                                      if (selfId) {
                                        setFieldValue(
                                          relationField,
                                          Number(selfId) || selfId,
                                          true,
                                        );
                                        setFieldTouched(
                                          relationField,
                                          true,
                                          false,
                                        );
                                        setTimeout(
                                          () => validateField(relationField),
                                          0,
                                        );
                                      }
                                    }
                                    setOpenSelect({ index: -1, type: "" });
                                  }}
                                >
                                  {a.AgeText}
                                </button>
                              ))}
                            </div>
                          )}
                      </div>
                      {errors.travellers?.[index]?.age &&
                        touched.travellers?.[index]?.age && (
                          <span className="edf-error">
                            ⚠ {errors.travellers[index].age}
                          </span>
                        )}
                    </div>

                    {/* Relation */}
                    <div className="edf-field-group">
                      <span className="edf-field-label">Relation</span>
                      <div className="ti-select">
                        <button
                          type="button"
                          disabled={index === 0}
                          className={`ti-select-btn${
                            openSelect.index === index &&
                            openSelect.type === "relation"
                              ? " is-open"
                              : ""
                          }`}
                          onClick={() => {
                            if (index === 0) return;
                            setOpenSelect((p) =>
                              p.index === index && p.type === "relation"
                                ? { index: -1, type: "" }
                                : { index, type: "relation" },
                            );
                          }}
                        >
                          <span>
                            {index === 0
                              ? selfRelationName
                              : traveller.relation
                                ? mastersData?.relationList?.find(
                                    (r) =>
                                      String(r.RelationID) ===
                                      String(traveller.relation),
                                  )?.RelationName || "Select"
                                : "Select"}
                          </span>
                          <span className="ti-select-caret">
                            {openSelect.index === index &&
                            openSelect.type === "relation" ? (
                              <MdArrowDropUp />
                            ) : (
                              <IoMdArrowDropdown />
                            )}
                          </span>
                        </button>
                        {openSelect.index === index &&
                          openSelect.type === "relation" && (
                            <div className="ti-select-menu">
                              {getAvailableRelations(index).map((r) => (
                                <button
                                  type="button"
                                  key={r.RelationID}
                                  className={`ti-select-item${
                                    String(traveller.relation) ===
                                    String(r.RelationID)
                                      ? " is-selected"
                                      : ""
                                  }`}
                                  onClick={() => {
                                    const nextId = r.RelationID;
                                    const nextNum = Number(nextId) || 0;

                                    if (
                                      nextNum &&
                                      childRelationIds.has(nextNum) &&
                                      (values.travellers || []).filter(
                                        (t, idx) =>
                                          idx !== index &&
                                          childRelationIds.has(
                                            Number(t.relation) || 0,
                                          ),
                                      ).length >= MAX_CHILDREN
                                    ) {
                                      toast.error("Maximum 2 children allowed");
                                      return;
                                    }

                                    if (
                                      nextNum &&
                                      spouseRelationIds.has(nextNum)
                                    ) {
                                      const a = Number(
                                        values.travellers?.[index]?.age,
                                      );
                                      if (
                                        Number.isFinite(a) &&
                                        a < MIN_ADULT_AGE
                                      ) {
                                        toast.error(
                                          "Spouse age must be 18 or above",
                                        );
                                        return;
                                      }
                                    }
                                    const isRestricted =
                                      nextNum &&
                                      restrictedRelationIds.has(nextNum);
                                    const alreadyTaken =
                                      isRestricted &&
                                      values.travellers?.some(
                                        (t, idx) =>
                                          idx !== index &&
                                          String(t.relation) === String(nextId),
                                      );
                                    if (alreadyTaken) {
                                      toast.warn(
                                        "This relation is already selected",
                                      );
                                      return;
                                    }
                                    const relationField = `travellers[${index}].relation`;
                                    setFieldValue(
                                      relationField,
                                      Number(nextId) || nextId,
                                      true,
                                    );
                                    setFieldTouched(relationField, true, false);
                                    setTimeout(
                                      () => validateField(relationField),
                                      0,
                                    );
                                    setOpenSelect({ index: -1, type: "" });
                                  }}
                                >
                                  {r.RelationName}
                                </button>
                              ))}
                            </div>
                          )}
                      </div>
                      {errors.travellers?.[index]?.relation &&
                        touched.travellers?.[index]?.relation && (
                          <span className="edf-error">
                            ⚠ {errors.travellers[index].relation}
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              ))}

              <button
                className="edf-add-btn"
                type="button"
                onClick={handleAddTraveller}
              >
                <svg
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 3v10M3 8h10" strokeLinecap="round" />
                </svg>
                Add Traveller
              </button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="edf-footer">
          <button
            className="edf-cancel-btn"
            type="button"
            onClick={() => closeModal(false)}
          >
            Cancel
          </button>
          <SubmitButton
            className="TraveL-BTN"
            text="Update Details"
            isLoading={isSubmitting}
            disabled={isSubmitting}
            onClick={handleUpdateClick}
            type="button"
          />
        </div>
      </div>
    </>
  );
};

export default EditDetailForm;
